module.exports = __webpack_public_path__ + "media/svg/entry-sheets-b2b0afff.svg";